import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alertModalContent container" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "buttonWrapper"
}

import { Button } from '@components';
import { markdownToHtml } from '@components/helpers';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertModalContent',
  props: {
    markdownContent: {},
    routeInformationLinkText: {},
    serviceStatusLinkText: {}
  },
  emits: ['buttonClick'],
  setup(__props: any) {

const props = __props;



const htmlContent = computed(() => markdownToHtml(props.markdownContent));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "content",
        innerHTML: _unref(markdownToHtml)(htmlContent.value)
      }, null, 8, _hoisted_3),
      (_ctx.routeInformationLinkText || _ctx.serviceStatusLinkText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.routeInformationLinkText)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  class: "routeInfoBtn",
                  "aria-label": _ctx.routeInformationLinkText,
                  label: _ctx.routeInformationLinkText,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('buttonClick', _ctx.routeInformationLinkText)))
                }, null, 8, ["aria-label", "label"]))
              : _createCommentVNode("", true),
            (_ctx.serviceStatusLinkText)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 1,
                  class: "serviceStatusBtn",
                  "aria-label": _ctx.serviceStatusLinkText,
                  label: _ctx.serviceStatusLinkText,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('buttonClick', _ctx.serviceStatusLinkText)))
                }, null, 8, ["aria-label", "label"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})